import Scale from "./editorToolbarElements/Scale";
import PageNavigation from "./editorToolbarElements/PageNavigation";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import {useSoftUIController} from "../../../../context";
import BrightnessComponent from "./editorToolbarElements/BrightnessComponent";
import { useTranslation } from "react-i18next";
import {Maximize2} from "lucide-react";
import {
    AppBar,
    Toolbar,
    Box,
    Divider,
    ThemeProvider,
    createTheme,
} from "@mui/material";


const darkTheme = createTheme({
    palette: {
        mode: "dark",
        primary: {
            main: "#2563EB",
        },
        background: {
            default: "#374151",
            paper: "#4B5563",
        },
        text: {
            primary: "#ffffff",
            secondary: "#D1D5DB",
        },
    },
    components: {
        MuiIconButton: {
            styleOverrides: {
                root: {
                    color: "#ffffff",
                    borderRadius: "4px", // Add smaller border radius
                    "&:hover": {
                        backgroundColor: "rgba(75, 85, 99, 0.8)",
                        borderRadius: "4px", // Minimize border radius on hover
                    },
                },
            },
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    color: "#ffffff",
                    border: "none",
                    borderRadius: "4px", // Add smaller border radius
                    "&:hover": {
                        backgroundColor: "grey.700",
                        borderRadius: "4px", // Minimize border radius on hover
                    },
                    "&.Mui-selected": {
                        backgroundColor: "#2563EB",
                        color: "#ffffff",
                        borderRadius: "4px", // Minimize border radius when selected
                        "&:hover": {
                            backgroundColor: "#1D4ED8",
                            borderRadius: "4px", // Minimize border radius on selected hover
                        },
                    },
                },
            },
        },
    },
})


const EditorToolbarComponent = ({
                                    handleFullScreen,
                                    isFullScreen,
                                    numPages,
                                    pageNumber,
                                    setForcePageNumber,
                                    setNotification,
                                    articleId,
                                    brightness,
                                    setBrightness,
                                    contrast,
                                    setContrast,
                                    zoom,
                                    setZoom
                                }) => {

    const [controller] = useSoftUIController();
    const {role} = controller;
    const {i18n} = useTranslation();
    const { t } = useTranslation(['editor']);
    const dir = i18n.dir();

    return (
        <ThemeProvider theme={darkTheme}>
            <Box sx={{width: "100%" }} dir={dir}>
                <AppBar
                    position="static"
                    sx={{
                        backgroundColor: "#222122",
                        boxShadow: "none",
                        borderBottom: "1px solid #4B5563",
                    }}
                >
                    <Toolbar sx={{justifyContent: "space-between", minHeight: "56px !important", px: 2, flexWrap: "wrap"}}>
                        <Box sx={{ display: "flex", alignItems: "center", flexDirection: { xs: "column", sm: "row" }, gap: { xs: 1, sm: 1 },
                            width: { xs: "100%", sm: "auto" },
                            flexWrap: "wrap"}}>


                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    backgroundColor: 'rgb(75 78 83 / 70%)',
                                    borderRadius: 2,
                                    px: 1,
                                    py: 0.5,
                                    width: { xs: "100%", sm: "auto" },
                                    justifyContent: { xs: "center", sm: "flex-start" }
                                }}
                            >
                            <Tooltip title={isFullScreen ? t('exit_full_screen') : t('full_screen')}>

                                <IconButton aria-label={isFullScreen ? t('exit_full_screen') : t('full_screen')}
                                            onClick={handleFullScreen}>
                                    {isFullScreen ? <Maximize2 size={16}/> :
                                        <Maximize2 size={16}/>
                                    }
                                </IconButton>
                            </Tooltip>

                            </Box>

                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    backgroundColor: 'rgb(75 78 83 / 70%)',
                                    borderRadius: 2,
                                    px: 1,
                                    py: 0.5,
                                    width: {xs: "100%", sm: "auto"},
                                    justifyContent: {xs: "center", sm: "flex-start"}
                                }}
                            >

                                <BrightnessComponent
                                    brightness={brightness}
                                    setBrightness={setBrightness}
                                    contrast={contrast}
                                    setContrast={setContrast}
                                />
                            </Box>



                            <Divider orientation="vertical" flexItem
                                     sx={{backgroundColor: "#6B7280", height: { xs: 1, sm: 36 },
                                         width: { xs: "100%", sm: "auto" },
                                         mx: 1,
                                         mt: { xs: 1, sm: "7px" }}}/>

                            <Box sx={{display: "flex", alignItems: "center", gap: 0.5}}>
                                <Scale
                                    scale={zoom}
                                    setScale={setZoom}
                                    t={t}
                                />
                            </Box>

                            <Divider orientation="vertical" flexItem
                                     sx={{backgroundColor: "#6B7280", height: { xs: 1, sm: 36 },
                                         width: { xs: "100%", sm: "auto" },
                                         mx: 1,
                                         mt: { xs: 1, sm: "7px" }}}/>


                                <PageNavigation
                                    pageNumber={pageNumber}
                                    numPages={numPages}
                                    setForcePageNumber={setForcePageNumber}
                                    t={t}
                                />
                        </Box>

                    </Toolbar>
                </AppBar>
            </Box>
        </ThemeProvider>
    );
}

EditorToolbarComponent.propTypes = {
    numPages: PropTypes.number,
    pageNumber: PropTypes.number,
    articleId: PropTypes.number,
    setForcePageNumber: PropTypes.func,
    handleFullScreen: PropTypes.func,
    setNotification: PropTypes.func,
    isFullScreen: PropTypes.bool,
    zoom: PropTypes.number,
    setZoom: PropTypes.func,
    brightness: PropTypes.number,
    contrast: PropTypes.number,
    setBrightness: PropTypes.func,
    setContrast: PropTypes.func,
};
export default EditorToolbarComponent;